import { render, staticRenderFns } from "./AppNavSearchItem.vue?vue&type=template&id=b475d80e&scoped=true&"
import script from "./AppNavSearchItem.vue?vue&type=script&lang=js&"
export * from "./AppNavSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./AppNavSearchItem.vue?vue&type=style&index=0&id=b475d80e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475d80e",
  null
  
)

export default component.exports